var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.hasOverlay ? 'active' : '',attrs:{"id":"overlay"},on:{"click":_vm.hideOverlay}})
}
var staticRenderFns = []

export { render, staticRenderFns }